import React, { useState } from 'react';
import Link from 'next/link';
import Image from 'next/image';
import { BiCalendar, BiUser, BiTime, BiImage } from 'react-icons/bi';
import { useTranslations } from '../../locales/useTranslations';

const FALLBACK_IMAGE = '/images/blog/default-blog.webp';

const BlogCard = ({ post }) => {
    const { t } = useTranslations();
    const [imgSrc, setImgSrc] = useState(post.image || FALLBACK_IMAGE);
    const [hasError, setHasError] = useState(false);

    // Prüfe ob das Bild ein SVG ist (basierend auf URL)
    const isSvgImage = imgSrc?.toLowerCase().includes('.svg');

    const handleImageError = () => {
        if (!hasError) {
            setHasError(true);
            setImgSrc(FALLBACK_IMAGE);
        }
    };

    return (
        <Link href={`/blog/${post.slug}`} className="blog-card">
            <div className={`blog-card-image ${isSvgImage ? 'blog-card-image--contain' : ''}`}>
                {hasError && imgSrc === FALLBACK_IMAGE ? (
                    <div className="blog-card-image-fallback">
                        <BiImage />
                    </div>
                ) : (
                    <Image
                        src={imgSrc}
                        alt={post.title}
                        fill
                        sizes="(max-width: 768px) 100vw, (max-width: 1200px) 50vw, 33vw"
                        style={{ objectFit: isSvgImage ? 'contain' : 'cover', objectPosition: 'center center' }}
                        onError={handleImageError}
                    />
                )}
                <div className="blog-card-category">
                    {post.category}
                </div>
            </div>

            <div className="blog-card-body">
                <div className="blog-card-meta">
                    <div className="blog-card-meta-item">
                        <BiCalendar />
                        {post.date}
                    </div>
                    <div className="blog-card-meta-item">
                        <BiTime />
                        {post.readTime} {t('blog_min_read')}
                    </div>
                </div>

                <h3 className="blog-card-title">
                    {post.title}
                </h3>

                <p className="blog-card-excerpt">
                    {post.excerpt}
                </p>

                <div className="blog-card-footer">
                    <div className="blog-card-author">
                        <div className="blog-card-author-avatar">
                            <BiUser />
                        </div>
                        <span className="blog-card-author-name">
                            {post.author}
                        </span>
                    </div>

                    <span className="blog-card-read-more">
                        {t('blog_read_more')} →
                    </span>
                </div>
            </div>
        </Link>
    );
};

export default BlogCard;
